var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzbitLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 80,
    viewBox: "0 0 174 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23438 38.5039H33.4163L29.5576 31.8661C28.7856 30.5408 27.3603 29.7236 25.8196 29.7236V29.7236H17.5474L24.6135 17.5638L50.2213 61.6412L68.7735 29.7236H58.5645L50.2213 44.0795L24.6135 0L2.23438 38.5039Z",
    fill: "url(#paint0_linear_1429_62815)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.253 34.9683H155.095V29.1667H149.253V34.9683ZM133.539 55.8205C130.126 55.8205 127.348 53.0627 127.348 49.6717C127.348 46.2818 130.126 43.5229 133.539 43.5229C136.952 43.5229 139.73 46.2818 139.73 49.6717C139.73 53.0627 136.952 55.8205 133.539 55.8205ZM133.539 37.7213C131.139 37.7213 128.904 38.426 127.024 39.6324V29.1681H121.183V61.0237H127.024V59.71C128.904 60.9175 131.139 61.6222 133.539 61.6222C140.174 61.6222 145.57 56.2612 145.57 49.6717C145.57 43.0822 140.174 37.7213 133.539 37.7213ZM171.766 37.8551V40.778C171.766 42.3673 170.468 43.6547 168.869 43.6547H165.925V51.0561C165.925 53.3774 167.818 55.2591 170.155 55.2591H171.766V61.0597H170.155C164.593 61.0597 160.085 56.5801 160.085 51.0561V29.1683H163.028C164.628 29.1683 165.925 30.4568 165.925 32.046V37.8551H171.766ZM95.6374 61.0599H116.737V58.0591C116.737 56.513 115.474 55.2572 113.915 55.2572H106.31L117.526 37.8553H97.068V43.6559H106.853L95.6374 61.0599ZM155.094 61.0864H149.252V37.8544H155.094V61.0864ZM79.2047 40.1704L75.2825 49.707H82.9183L79.2047 40.1704ZM93.6017 61.06H90.1147C88.4427 61.06 86.9422 60.0377 86.3375 58.4894L85.0753 55.2573H72.9994L70.6137 61.06H64.3047L76.5754 30.9725C77.0254 29.8797 78.0918 29.1687 79.2778 29.1687C80.4839 29.1687 81.5682 29.9049 82.0023 31.0209L93.6017 61.06Z",
    fill: "url(#paint1_linear_1429_62815)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1429_62815",
    x1: 2.23438,
    y1: 0,
    x2: 76.0678,
    y2: 10.5388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FCC98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1429_62815",
    x1: 118.035,
    y1: 29.1667,
    x2: 118.035,
    y2: 61.6222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#262728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3E40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzbitLogo);
export default __webpack_public_path__ + "static/media/azbit-logo.bc66eed16c1f86a7853c9bc67da1a4ab.svg";
export { ForwardRef as ReactComponent };